import React from "react";
import { Box, List, ListItemButton, ListItemText, Typography, Stack } from "@mui/material";

const ExpeditedOrdersList = ({ orders, selectedOrderId, onSelect, showHeader = true }) => {
  return (
    <Box
      sx={{
        width: "320px",
        borderRight: "1px solid #e6e6e6",
        height: "100%",
        overflowY: "auto",
      }}
    >
      {showHeader && (
        <Box sx={{ p: 2, borderBottom: "1px solid #eee" }}>
          <Typography variant="h6">Active Expedited Orders</Typography>
          <Typography variant="body2" color="text.secondary">
            Click an order to view nearby drivers
          </Typography>
        </Box>
      )}

      <List>
        {orders.map((o) => {
          const orderNumber = o.orderNumber ?? "";
          const senderName = o.senderName ?? "";
          const senderPhone = o.senderPhone ?? "";

          return (
            <ListItemButton
              key={o.orderId}
              selected={selectedOrderId === o.orderId}
              onClick={() => onSelect(o.orderId)}
              sx={{ py: 2 }}
            >
              <Stack spacing={0.5} sx={{ width: "100%" }}>
                <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                  {orderNumber || "Order"}
                </Typography>
                {senderName && (
                  <Typography variant="body1">
                    <strong>Sender Name:</strong> {senderName}
                  </Typography>
                )}
                {senderPhone && (
                  <Typography variant="body1">
                    <strong>Sender Phone:</strong> {senderPhone}
                  </Typography>
                )}
              </Stack>
            </ListItemButton>
          );
        })}
      </List>
    </Box>
  );
};

export default ExpeditedOrdersList;
